<template>
  <a-config-provider :locale="languageState.currentLocale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'

// 获取初始语言设置（优先级：URL参数 > sessionStorage > 默认英语）
function getInitialLanguage() {
  const urlParams = new URLSearchParams(window.location.search)
  const urlLang = urlParams.get('lang')
  
  if (urlLang === 'zh' || urlLang === 'en') {
    sessionStorage.setItem('userLanguage', urlLang)
    return urlLang
  }
  
  const localLang = sessionStorage.getItem('userLanguage')
  if (localLang === 'zh' || localLang === 'en') {
    return localLang
  }
  
  return 'en' // 默认英语
}

export default {
  name: 'App',
  data() {
    // 获取初始语言
    const lang = getInitialLanguage()
    
    return {
      // 将语言状态包装在一个对象中，确保响应性
      languageState: {
        currentLanguage: lang, // 默认英语
        currentLocale: lang === 'en' ? enUS : zhCN
      }
    }
  },
  provide() {
    return {
      languageState: this.languageState,
      changeLanguage: this.changeLanguage
    }
  },
  methods: {
    changeLanguage(lang) {
      if (lang === 'en') {
        this.languageState.currentLocale = enUS
        this.languageState.currentLanguage = 'en'
        sessionStorage.setItem('userLanguage', 'en')
      } else {
        this.languageState.currentLocale = zhCN
        this.languageState.currentLanguage = 'zh'
        sessionStorage.setItem('userLanguage', 'zh')
      }
    }
  }
}
</script>

<style>
html,
body {
  width: 100%;
  min-width: 0;
  margin: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  min-width: 0;
}

@media (max-width: 768px) {
  html,
  body,
  #app {
    max-width: 100%;
  }

  .main-layout-content > * {
    min-width: 0;
    max-width: 100%;
  }

  /* Public landing pages animate cards from the sides; contain those transforms
     so they cannot create a page-level horizontal scrollbar on mobile. */
  .home-page,
  .dynamic-house-page,
  .static-house-page {
    max-width: 100%;
    overflow-x: hidden;
  }

  .main-layout-content .ant-card,
  .main-layout-content .ant-card-body,
  .main-layout-content .ant-table-wrapper {
    min-width: 0;
    max-width: 100%;
  }

  .main-layout-content .ant-table-body {
    overflow-x: auto !important;
    -webkit-overflow-scrolling: touch;
  }

  .main-layout-content .ant-pagination {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    row-gap: 8px;
  }

  .main-layout-content .ant-pagination-total-text {
    flex-basis: 100%;
    margin-right: 0;
    text-align: center;
  }

  .ant-modal {
    width: calc(100vw - 32px) !important;
    max-width: calc(100vw - 32px);
    margin: 0 auto;
    top: 32px;
    padding-bottom: 32px;
  }

  .ant-modal-body {
    max-height: calc(100vh - 180px);
    overflow-y: auto;
  }
}
</style>
